<ngb-timepicker [meridian]="meridian" [formControl]="control"></ngb-timepicker>
